(function () {
    'use strict';

    angular.module("imApp").factory("stockBatchCorrQtyService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockBatchCorrQty: function (parms) {
                return $ihttp.post({
                    method: 2480,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2481,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();